module.exports = __webpack_public_path__ + "static/media/pianogogo_logo.69d5fee5.png";